import React, {useState} from "react";
import {Space, Table} from "antd";
import moment from "moment";
import PalletFilterPrintBar from "../pallet-filter-print-bar";

const MaterialTableOfShelf = (props:{data:any}) =>{
    const [palletFilter, setPalletFilter] = useState<string | null>(null);
    const pallets: string[] = Array.from(new Set((props.data || []).map((item: any) => item.palletNo).filter(Boolean)));
    const dataSource = palletFilter
        ? props.data.filter((item: any) => item.palletNo === palletFilter)
        : props.data;
    const columns:any =[
        {
            title: 'Material Name',
            dataIndex: ['rawMaterial', 'rawMaterialName'],
            key: 'productName',
        },
        {
            title: 'Material Code',
            dataIndex: ['rawMaterial','rawMaterialCode'],
            key: 'barCode',
        },
        {
            title: 'Qty',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Position',
            dataIndex: 'position',
            key: 'position',
        },
        {
            title: 'Pallet',
            dataIndex: 'palletNo',
            key: 'palletNo',
        },            
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (rowData: any) =>moment.utc( rowData.createdAt).local().format('DD/MM/YYYY'),
        },
       
        // {
        //     title: 'Action',
        //     key: 'action',
        //     render: (text:any, record:any) => {
        //         console.log(text,record)
        //         return(
        //             <Space size="middle">
        //                 {/*<a>Invite {record.name}</a>*/}
        //                 <a>Delete</a>
        //             </Space>
        //         )
        //     },
        // },
    ]
    return (
        <div>
            <PalletFilterPrintBar
                pallets={pallets}
                value={palletFilter}
                onChange={setPalletFilter}
                info={`${pallets.length} pallets · ${(props.data || []).length} boxes`}
            />
            <Table columns={columns} dataSource={dataSource}/>
        </div>
    )
}

export default MaterialTableOfShelf
